import { render, staticRenderFns } from "./CloudRecomend.vue?vue&type=template&id=04d5f058&"
import script from "./CloudRecomend.vue?vue&type=script&lang=js&"
export * from "./CloudRecomend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports